module.exports = __webpack_public_path__ + "img/197.70cfac16.jpg";